<div class="modal-content">
  <h2 mat-dialog-title class="font-text">Confirmar borrado</h2>

  <mat-dialog-actions align="end">
    <button mat-button  class="font-text" (click)="noDelete()">NO</button>
    <button mat-button  cdkFocusInitial  class="font-text" (click)="delete()">SÍ</button>
  </mat-dialog-actions>
</div>